// @services/clients/AccountClient.ts
import type { AccountClient as InteropAccountClient } from '@ps-bridge/clients/account';
import type { AccountError, AccountResponse } from '@ps-bridge/models/core/dataContracts';
import type { TaskEitherTs } from '@ps-bridge/interop';
import { taskEitherFromRaw } from '@utils/effects/branded';

export interface AccountClient {
    readonly getAccountDetails: TaskEitherTs<AccountError, AccountResponse>;
}

export const fromInteropAccountClient = (client: InteropAccountClient): AccountClient => ({
    getAccountDetails: taskEitherFromRaw(client.getAccountDetails),
});
